import clsx from 'clsx';
import React, { forwardRef, useState } from 'react';
import Button from '../../Button/Button';
import Icon from '../../Icon/Icon';
import styles from './Input.module.css';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  prefix?: string;
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', prefix = '', type, ...rest }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const inputType = type === 'password' && showPassword ? 'text' : type;

    const handleSetShowPassword = (event: React.MouseEvent) => {
      event.stopPropagation(); // Prevents `useClickOutside` from being fired immediately
      event.preventDefault(); // Prevents nested embedded links to be fired
      setShowPassword((prev) => !prev);
    };

    return (
      <div
        className={clsx(styles.container, {
          [styles.hasPrefix]: !!prefix,
        })}
        data-prefix={prefix}
      >
        <input
          className={clsx(styles.input, className)}
          style={{
            paddingLeft: `${prefix?.length * 1 + 0.8}rem`,
          }}
          type={inputType}
          ref={ref}
          {...rest}
        />
        {type === 'password' ? (
          <Button
            theme="none"
            className={styles.showPasswordButton}
            tabIndex={-1}
            onClick={handleSetShowPassword}
          >
            {showPassword ? (
              <div
                onClick={handleSetShowPassword}
                role="button"
                tabIndex={0}
                className={styles.eyeContainer}
              >
                <Icon name="eyeClosed" className={styles.icon} />
              </div>
            ) : (
              <div
                onClick={handleSetShowPassword}
                role="button"
                tabIndex={0}
                className={styles.eyeContainer}
              >
                <Icon name="eyeOpen" className={styles.icon} />
              </div>
            )}
          </Button>
        ) : null}
      </div>
    );
  }
);

export default Input;
